import $ from "jquery"


# ==================================================
# > INCREMENTOR
# ==================================================
import "./../tools/incrementor.coffee"

$ -> $(".incrementor").each (i, el) -> $(el).incrementor 2000


# ==================================================
# > PARALLAX
# ==================================================
import skrollr from "skrollr"

class Parallax
    constructor: ->
        @parallax = skrollr.init
            forceHeight: false
            smoothScrolling: false
            smoothScrollingDuration: 0

        @exists = true

        if @parallax.isMobile() then @destroy()
        $(window).resize => @resize()

    destroy: ->
        @parallax.destroy()
        @exists = false

    resize: ->
        unless @exists then return false
        @parallax.refresh()

$ -> new Parallax



// WEBPACK FOOTER //
// ./scripts/modules/animations.coffee